import React, { Component } from "react";
import DistribucionLimite from "./DistribucionLimite";

class LimiteCompraTarjeta extends Component {
    constructor(props) {
        super(props);
    }   

    render() {
        const { data, tarjeta, tarjetas } = this.props;
        let componente = null;

        const limitesTarjetas = tarjetas.map((t) => {
            return (
                <DistribucionLimite Denominacion={t.Denominacion}
                    Porcentaje={t.PorcentajeLimiteCompra}
                    key={"PorcentajeLimiteCompra_" + t.TarjetaCreditoId}
                />
            );
        })

        return <div className="col-xs-12">
            <div className="row bottom-separator-xs">
                <div className="col-xs-12">
                    <div className="row">
                        <div className="col-xs-12">
                            <label className="label-primary">Límite de Compra (% del límite de la cuenta)</label>
                        </div>
                    </div>
                    <label className="label-secondary" >{tarjeta.PorcentajeLimiteCompra}</label>
                    <div className="row">
                        <div className="col-xs-12">
                            <div className="btn-group dropup">
                                <a className="clickable dropdown-toggle dropdown-toggle-split" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    Ver Límites
                                </a>
                                <div className="dropdown-menu dropdown-popup" >
                                    <div>
                                        <div className="row">
                                            <div className="col-md-12">
                                                <label className="label-primary">Tarjetas</label>
                                            </div>
                                        </div>
                                        {limitesTarjetas}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
}

export default LimiteCompraTarjeta;